let wrapper = document.querySelector('.masonry-wrapper')

if(wrapper) {
  document.addEventListener('turbo:load', () => {
    new Masonry( '.masonry-wrapper', {  // eslint-disable-line no-undef
      itemSelector: '.masonry-elem',
      percentPosition: true
    })
  })
}